import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementBuildingsIndexScene from 'scenes/management/buildings/buildings'
import ManagementBuildingBuildingScene from 'scenes/management/buildings/building'
import ManagementBuildingContactScene from 'scenes/management/buildings/contact'
import ManagementBuildingFloorScene from 'scenes/management/buildings/floor'
import ManagementBuildingRoomScene from 'scenes/management/buildings/room'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_BUILDINGS_BUILDINGS_INDEX]: {
		component: ManagementBuildingsIndexScene,
	},
	[AppRoutes.MANAGEMENT_BUILDINGS_BUILDINGS_VIEW]: {
		component: ManagementBuildingBuildingScene,
	},
	[AppRoutes.MANAGEMENT_BUILDINGS_CONTACT]: {
		component: ManagementBuildingContactScene,
	},
	[AppRoutes.MANAGEMENT_BUILDINGS_FLOOR]: {
		component: ManagementBuildingFloorScene,
	},
	[AppRoutes.MANAGEMENT_BUILDINGS_ROOM]: {
		component: ManagementBuildingRoomScene,
	},
}

const ManagementBuildingsNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>
			
			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `HomeBuildingsNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
}

export default ManagementBuildingsNavigator
